import React, { useEffect } from "react";
import "./AssignList.scss";
import { Col, Divider, Row, Space, Table, Input, Checkbox } from "antd";
import Icons from "assets/icons";
import AllocateTableSearch from "./components/AllocateTableSearch/AllocateTableSearch";
import ServiceTable from "./components/ServiceTable/ServiceTable";
import { TableDetail } from "components/common/Table/TableDetail";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setListAssign } from "redux/reducer/listAssign";

const AssignList = () => {
  let dispatch = useAppDispatch();
  let idPKNT = useAppSelector(state => state.examination.idPKNT);

  useEffect(() => {
    dispatch(setListAssign([]))
  }, [idPKNT])
  return (
    <div className="assign-list-container">
      <Divider />
      <Space className="assign-list-space" direction="vertical" size={"middle"}>
        <Row gutter={[16, 16]}>
          <Col xl={6} sm={24} xs={24}>
            <AllocateTableSearch />
          </Col>
          <Col xl={18} sm={24} xs={24}>
            <ServiceTable />
          </Col>
          {/* <Col span={24}>
            <TableDetail />
          </Col> */}
        </Row>
      </Space>
    </div>
  );
};

export default AssignList;
